import React, { useState } from 'react';
import './StatusFooter.css';
import statusLogoSvg from '../../assets/Status_Solutions_Logo-reverse-01.svg';
import statusLogoMobileSvg from '../../assets/StatusSolutionsLogoMobile.svg';
import logComponent from '../../common/logComponent';
import networkDirectoryLogo from '../../assets/Status Solutions Network Logo-footer.png';
import networkDirectoryMobileLogo from '../../assets/StatusSolutionsNetworkLogoSmall.svg';
import Eula from '../Eula/Eula';
import viewport from '../../common/viewport';
import PrivacyPolicy from '../PrivacyPolicy/PrivacyPolicy';
import ContactUs from '../ContactUs/ContactUs';

export default function StatusFooter() {
  const [viewportIsSm, setViewportIsSm] = useState(viewport.isOldSm());
  if (logComponent('StatusFooter')) { console.debug('StatusFooter rendered'); }

  return (
    <div className="Status-Footer">
      {
        viewportIsSm &&
        <React.Fragment>
          <div className="Status-Footer__footer-status-logo">
            <img src={statusLogoMobileSvg} alt="Powered By Status Solutions" />
          </div>
          <div className="Status-Footer__footer-links-and-copyright">
            <div className="Status-Footer__footer-links-and-copyright__links">
              <Eula />
              <PrivacyPolicy />
              <ContactUs />
            </div>
            <div className="Status-Footer__footer-links-and-copyright__copyright">
              <p>Copyright &copy; {(new Date().getFullYear())}. Status Solutions </p>
            </div>
          </div>
          <div className="Status-Footer__footer-network-directory">
            <a target="_blank" rel="noopener noreferrer" href="https://www.statussolutionsnetwork.com/" >
              <img src={networkDirectoryMobileLogo} alt="The Network Directory" />
            </a>

          </div>
        </React.Fragment>
      }
      {
        !viewportIsSm &&
        <React.Fragment>
          <div className="Status-Footer__footer-status-logo">
            <img src={statusLogoSvg} alt="Powered By Status Solutions" />
          </div>
          <div className="Status-Footer__footer-links-and-copyright">
            <div className="Status-Footer__footer-links-and-copyright__links">
              <Eula />
              <PrivacyPolicy />
              <ContactUs />
            </div>
            <div className="Status-Footer__footer-links-and-copyright__copyright">
              <p>Copyright &copy; {(new Date().getFullYear())}. Status Solutions, LLC.All Rights Reserved. </p>
            </div>
          </div>
          <div className="Status-Footer__footer-network-directory">
            <a target="_blank" rel="noopener noreferrer" href="https://www.statussolutionsnetwork.com/" >
              <img src={networkDirectoryLogo} alt="The Network Directory" />
            </a>

          </div>
        </React.Fragment>
      }
    </div>
  );
  
}

